import React, {useState} from 'react';
import {Form, Input, Button, Checkbox, Carousel, AutoComplete} from 'antd';
import {UserOutlined, LockOutlined, CopyrightOutlined} from '@ant-design/icons';
import {http, history} from 'libs';
import styles from './login.module.less';
import bannerEn1 from './banner/en/1.jpeg'
import bannerEn2 from './banner/en/2.jpeg'
import bannerEn3 from './banner/en/3.jpeg'

import bannerZh1 from './banner/zh/1.jpeg'
import bannerZh2 from './banner/zh/2.jpeg'
import bannerZh3 from './banner/zh/3.jpeg'

// the hook
import {useTranslation} from 'react-i18next';

const {Option} = AutoComplete;
const {Password} = Input

export default function Login() {
  const {t, i18n} = useTranslation();
  const [loading, setLoading] = useState(false);
  const [org, setOrg] = useState('')
  const [orgList, setOrgList] = useState([])

  function handleSubmit(formData) {
    setLoading(true);
    formData['from'] = '2';
    let data = {
      username: formData.phone,
      password: formData.password,
      from:2
    }
    // return
    http.post('/frontApi/api/register/', formData)
      .then(() => {
        http.post('/frontApi/api/login/', data)
          .then(data => {

            localStorage.setItem('token', data['token']);
            localStorage.setItem('username', data['username']);
            localStorage.setItem('password', data['password']);
            localStorage.setItem('remember', formData['remember']);


            http.get('/frontApi/customer/get_user_info/')
              .then(data => {
                localStorage.setItem('nickname', data['name']);
                localStorage.setItem('userInfo', JSON.stringify(data));
                // localStorage.setItem('is_supper', data['is_supper']);

                if (history.location.state && history.location.state['from']) {
                  history.push(history.location.state['from'])
                } else {
                  let redirect_uri = localStorage.getItem('redirect_uri')
                  history.push(redirect_uri ? redirect_uri : '/home')
                }

              })


          }, () => setLoading(false))
      })
  }

  function getOrganization(val) {
    http.post('/frontApi/data/get_organization/', encodeURI('organization=' + val))
      .then((data) => {
        setOrgList(data['organization'])
      })
      .finally(() => setLoading(false))
  }

  return (
    <div className={[styles.container, styles.register].join(" ")}>

      <div className={styles.carousel}>
        {/* <Carousel autoplay>
          <div>
            <div className={styles.item}
                 style={{backgroundImage: 'url("' + (i18n.language === 'en' ? bannerEn1 : bannerZh1) + '")'}}/>
          </div>
          <div>
            <div className={styles.item}
                 style={{backgroundImage: 'url("' + (i18n.language === 'en' ? bannerEn2 : bannerZh2) + '")'}}/>
          </div>
          <div>
            <div className={styles.item}
                 style={{backgroundImage: 'url("' + (i18n.language === 'en' ? bannerEn3 : bannerZh3) + '")'}}/>
          </div>
        </Carousel> */}
      </div>


      <div className={styles.formContainer}>
        <div className={styles.h1}>{t('欢迎加入Lab Direct平台')}</div>
        <div className={styles.formTip}>
          {t('如果您已有平台账号')} <a onClick={() => {
          history.push('/login')
        }}>{t('立即登录')}!</a>
        </div>
        <Form onFinish={handleSubmit} validateTrigger='onBlur'>

          <Form.Item
            label={t('电子邮箱')}
            name="email"
            rules={[
              {required: true, message: t('请输入电子邮箱') + '!'},
              {type: 'email', message: t('输入的电子邮箱格式有误') + '!'}
            ]}
            className={styles.formItem}>
            <Input autoComplete="off" placeholder={t('此电子邮箱账号即为登录名')}/>
          </Form.Item>

          <Form.Item
            label={t('手机号码')}
            name="phone"
            rules={[
              {required: true, message: t('请输入您的手机号') + '!'},
              {pattern: /^[1]([3-9])[0-9]{9}$/, message: t('请输入正确的手机号码')}
            ]}
            className={styles.formItem}>
            <Input autoComplete="off" placeholder={t('请输入您的手机号')}/>
          </Form.Item>

          <Form.Item
            label={t('姓名')}
            name="name"
            rules={[
              {required: true, message: t('请输入您的姓名') + '!'},
              {pattern: /^\S{2,10}$/, message: t('姓名为2-10个非空字符')}
            ]}
            className={styles.formItem}>
            <Input autoComplete="off" placeholder={t('请输入您的姓名')}/>
          </Form.Item>


          <Form.Item
            label={t('设置密码')}
            name="password"
            rules={[
              {required: true, message: t('请输入6-10位由数字字母特殊符号组成的密码') + '!'},
              {pattern: /^.{6,10}$/, message: t('请输入6-10位由数字字母特殊符号组成的密码') + '!'}
            ]}
            className={styles.formItem}>
            <Password className='rest-password' placeholder={t('请输入6-10位由数字字母特殊符号组成的密码') + '!'}/>
          </Form.Item>

          <Form.Item
            label={t('确认密码')}
            name=""
            dependencies={['password']}
            rules={[
              {required: true, message: t('请再次输入密码') + '!'},
              ({getFieldValue}) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(t('两次输入的密码不匹配') + '!');
                },
              }),
            ]}
            className={styles.formItem}>
            <Password className='rest-password' placeholder={t('请再次输入密码')}/>
          </Form.Item>


          <Form.Item
            label={t('公司名称')}
            name="organization_str"
            rules={[{required: true, message: t('请输入公司名称') + '!'}]}
            className={styles.formItem}>
            {/*<AutoComplete
              className='rest-select'
              onSelect={(val) => {
                setOrg(val)
              }}
              onSearch={getOrganization}
              allowClear
              placeholder="请输入公司名称">
              {orgList.map((item) => (
                <Option key={item['id']} value={item['name']}>
                  {item['name']}
                </Option>
              ))}
            </AutoComplete>*/}

            <Input autoComplete="off" placeholder={t('请输入公司名称')}/>

          </Form.Item>


          <Form.Item>
            <Button size="large" type="primary" htmlType="submit" loading={loading}>{t('同意协议并注册')}</Button>
            <div className={styles.formTip}>
              <a className="theme_color" target='_blank'
                 href="#">{'《' + t('会员注册协议') + '》'}</a>
              {t('和')}
              <a className="theme_color" target='_blank'
                 href="#">{'《' + t('隐私保护政策') + '》'}</a>
            </div>
          </Form.Item>

        </Form>
      </div>

    </div>
  )
}
